/**
 * Component Registry for Apartment Management Consultants Theme
 * 
 * Extends the base avenue theme registry with Apartment Management Consultants specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-avenue/registry';
import { ApplyAccess } from './components/ApplyAccess';
import { PropertyFeeGuide } from './components/PropertyFeeGuide';
import { Footer } from './components/Footer';
import { PageHero } from './components/PageHero';
import { PageBlurb } from './components/PageBlurb';
import { Hero } from './components/Hero';
import { Header } from './components/Header';
import { SocialFollow } from './components/SocialFollow';
import { CTASection } from './components/CTASection';
import { ReviewsCallout } from './components/ReviewsCallout';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { FloorplansList } from './components/FloorplansList';
import { FloorPlanDetailsShortcode } from './components/FloorPlanDetailsShortcode';

/**
 * Apartment Management Consultants specific component overrides.
 * These components have been customized for the Apartment Management Consultants brand.
 */
const apartmentmanagementconsultantsOverrides: Partial<ComponentRegistry> = {
  ApplyAccess,
  PropertyFeeGuide,
  Footer,
  PageHero,
  PageBlurb,
  Hero,
  Header,
  SocialFollow,
  CTASection,
  ReviewsCallout,
  ScheduleTourForm,
  FloorplansList,
  FloorPlanDetailsShortcode,
};

/**
 * Final merged registry for Apartment Management Consultants properties.
 * Inherits all components from the avenue theme, with Apartment Management Consultants overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...apartmentmanagementconsultantsOverrides,
};

export default registry;
